import React from 'react'

import {
  Body2,
  Box,
  Checkbox,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Heading5,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

import type { DisplayPreference } from '@library/api-menu-experience'

import { RecipeInformationPreview } from './RecipeInformationPreview'

type RecipeInformationPreferencesProps = {
  displayPreferences: DisplayPreference[]
  maxSelectedDisplayPreferences?: number
  onChange: (displayPreferences: DisplayPreference[]) => void
}

const MAX_SELECTED_DISPLAY_PREFERENCES = 5

export const RecipeInformationPreferences = ({
  displayPreferences,
  maxSelectedDisplayPreferences = MAX_SELECTED_DISPLAY_PREFERENCES,
  onChange,
}: RecipeInformationPreferencesProps) => {
  const selectedCount = displayPreferences.filter(({ selected }) => selected).length

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target
    const updatedPreferences = displayPreferences.map((preference) =>
      preference.type === name ? { ...preference, selected: checked } : preference,
    )
    onChange(updatedPreferences)
  }

  return (
    <Box paddingV={2}>
      <Heading5>Recipe information</Heading5>
      <Body2>Customise recipe information. Select up to {maxSelectedDisplayPreferences}:</Body2>
      <Space size={3} direction="vertical" />
      <RecipeInformationPreview displayPreferences={displayPreferences} />
      <Space size={3} direction="vertical" />
      {displayPreferences.map((preference) => {
        const isDisabled = !preference.selected && selectedCount >= maxSelectedDisplayPreferences

        return (
          <Box key={preference.type} paddingBottom={2}>
            <Checkbox
              id={`recipe-information-${preference.type}`}
              name={preference.type}
              checked={preference.selected}
              disabled={isDisabled}
              onChange={handleChange}
              outline
              paddingH={3}
              paddingV={3}
            >
              <Box display={Display.Flex} flexGrow={1} flexDirection={FlexDirection.Column}>
                <Text
                  color={preference.selected ? Color.Secondary_400 : Color.ColdGrey_800}
                  fontWeight={preference.selected ? FontWeight.Bold : FontWeight.Normal}
                  size={3}
                >
                  {preference.name}
                </Text>
              </Box>
            </Checkbox>
          </Box>
        )
      })}
    </Box>
  )
}
